import Amplify from "aws-amplify";
import { getHeaderAuth } from "../utils/utilAmplify";
import { API_CHATS, API_HOUSES, API_MATCHES, API_USERS } from "../utils/constants";

const endPointHospi = process.env.REACT_APP_AWS_ENDPOINT;

export enum ServiceName {
  UsersProfile = "UsersProfile",
  HostHouse = "HostHouse",
  StudentMatches = "StudentMatches",
  HostMatches = "HostMatches",
  UserChats = "UserChats"
}

export const initAmplify = (): void => {
  Amplify.configure({
    Auth: {
      identityPoolId: process.env.REACT_APP_POOL_ID,
      region: process.env.REACT_APP_REGION,
      identityPoolRegion: process.env.REACT_APP_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_WEB_CLIENT_ID
    },
    API: {
      endpoints: [
        {
          name: ServiceName.UsersProfile,
          endpoint: endPointHospi + API_USERS,
          region: process.env.REACT_APP_REGION,
          custom_header: getHeaderAuth
        },
        {
          name: ServiceName.HostHouse,
          endpoint: endPointHospi + API_HOUSES,
          region: process.env.REACT_APP_REGION,
          custom_header: getHeaderAuth
        },
        {
          name: ServiceName.StudentMatches,
          endpoint: endPointHospi + API_MATCHES,
          region: process.env.REACT_APP_REGION,
          custom_header: getHeaderAuth
        },
        {
          name: ServiceName.HostMatches,
          endpoint: endPointHospi + API_MATCHES,
          region: process.env.REACT_APP_REGION,
          custom_header: getHeaderAuth
        },
        {
          name: ServiceName.UserChats,
          endpoint: endPointHospi + API_CHATS,
          region: process.env.REACT_APP_REGION,
          custom_header: getHeaderAuth
        }
      ]
    }
  });
};
